import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import {
	TEasInfoGroup,
	TEasInfoListRequest,
	TEasInfoListResponsePayload,
	TEasInfoStore,
} from './types';

export const getEasInfoState = (state: TStoreState): TEasInfoStore => state.easInfo;

export const getEasInfoList = createSelector(
	[getEasInfoState],
	(easInfo: TEasInfoStore) => easInfo.easInfoList,
);

export const getEasInfoListData = createSelector(
	[getEasInfoList],
	(easInfoList: TEasInfoListResponsePayload | null) => easInfoList,
);

export const getEasInfoListLoading = createSelector(
	[getEasInfoState],
	(easInfo: TEasInfoStore) => easInfo.easInfoListLoading,
);

export const getEasInfoLastListParams = createSelector(
	[getEasInfoState],
	(easInfo: TEasInfoStore): TEasInfoListRequest | null => easInfo.lastListParams,
);

export const getEasInfoGroups = createSelector(
	[getEasInfoState],
	(easInfo: TEasInfoStore): TEasInfoGroup[] | null => easInfo.groups,
);

export const getEasInfoGroupsLoading = createSelector(
	[getEasInfoState],
	(easInfo: TEasInfoStore) => easInfo.groupsLoading,
);

export const getEasInfoPatchLoading = createSelector(
	[getEasInfoState],
	(easInfo: TEasInfoStore) => easInfo.patchLoading,
);

export const getEasInfoPatchSuccess = createSelector(
	[getEasInfoState],
	(easInfo: TEasInfoStore) => easInfo.patchSuccess,
);

export const getEasInfoUpdateLoading = createSelector(
	[getEasInfoState],
	(easInfo: TEasInfoStore) => easInfo.updateLoading,
);

export const getEasInfoUpdateSuccess = createSelector(
	[getEasInfoState],
	(easInfo: TEasInfoStore) => easInfo.updateSuccess,
);
